// 評価アイコン（★/♦）の配色を一元管理する。
// Tailwind JIT が検出できるよう、必ず静的リテラルで定義すること。
export const RATING_COLORS = {
  self: 'fill-yellow-400 text-yellow-400', // 自己評価
  aiStar: 'fill-green-500 text-green-500', // AI ★(1〜5)
  aiDiamond: 'fill-purple-500 text-purple-500', // AI ♦(6〜10)
  empty: 'text-muted-foreground/30', // 未点灯
} as const

// 絞り込みボタンの「選択中」表現（細い色付き枠線＋薄い同系ティント）。
// Tailwind JIT 検出のため静的リテラルで定義する。
export const RATING_SELECTED = {
  self: 'border-yellow-400 bg-yellow-400/10', // 自己評価
  aiStar: 'border-green-500 bg-green-500/10', // AI ★(1〜5)
  aiDiamond: 'border-purple-500 bg-purple-500/10', // AI ♦(6〜10)
} as const
